import React, { useState, useRef, useEffect } from "react";
import { Table, Dropdown } from "react-bootstrap";
import defaultProfileImage from "../../../../images/avatar/1.jpg";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { useParams } from "react-router-dom"
// import DonorTablePDF from "../PDF/DonorTablePDF";
import DonorPrintModal from "../modal/DonorPrintModal";



import * as XLSX from "xlsx";


import { Link } from "react-router-dom";

const DonorTable = (props) => {
    
    const { type } = useParams();

    const [activePage, setActivePage] = useState(0);
    const [pageSize] = useState(10); // Adjust `pageSize` as needed
    const [largeModal, setLargeModal] = useState(false);
    // Calculate total pages based on totalEligibleDonors from props
    const totalPages = Math.ceil(props.totalEligibleDonors / pageSize);

    useEffect(() => {
        props.fetchDonorsByType(type, activePage * pageSize, pageSize);
    }, [activePage]);

    const handlePageClick = (pageIndex) => {
        setActivePage(pageIndex); // Update the active page
    };

    const exportToPDF = () => {
        const doc = new jsPDF();
        const logo = "../../../../../images/AideaLogo.png"; // Path to your logo image
    
        // Add logo to the header
        doc.addImage(logo, "PNG", 10, 10, 50, 20); // Position it at (10, 10) with width 50 and height 20
    
        // Add title below the logo
        doc.setFontSize(16);
        doc.text("Donor Data Report", 70, 15); // Adjust position accordingly
    
        // Add table below the header
        doc.autoTable({
            head: [["Donor ID", "Gender", "Name", "Status"]],
            body: props.eligibleDonors.map(donor => [
                donor._id,
                donor.gender,
                donor.firstName + " " + donor.secondName,
                donor.status,
            ]),
            startY: 40, // Position the table below the header
        });
    
        doc.save("DonorData1.pdf");
    };
    


    // Export to Excel function
    const exportToExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(
            props.eligibleDonors.map(donor => ({
                "Donor ID": donor._id,
                "Gender": donor.gender,
                "Name": donor.firstName + " " + donor.secondName,
                "Status": donor.status,
                "Donor Token": donor.donorToken,
            }))
        );
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Donor Data");
        XLSX.writeFile(workbook, "DonorData.xlsx");
    };

    return (


        <div className="col-12">
            <div className="card">
                <div className="card-header">
                <h4 className="card-title">Donors</h4>
                    <DonorPrintModal largeModal={largeModal} setLargeModal={setLargeModal} donors={props.eligibleDonors} />
                    
                    <div style={{ display: "inline-flex", gap: "8px" }}>
                        <button  onClick={() => setLargeModal(true)} className="btn btn-primary">
                            Export PDF
                        </button>
                        {/* <DonorTablePDF donors={props.eligibleDonors} /> */}
                        <button onClick={exportToExcel} className="btn btn-primary">
                            Export Excel    
                        </button>
                    </div>
                </div>
                <div className="card-body">
                    <div className="w-100 table-responsive">
                        <div id="patientTable_basic_table" className="dataTables_wrapper">
                            <table
                                id="example5"
                                className="display dataTable no-footer w-100"
                                style={{ minWidth: 845 }}
                                role="grid"
                                aria-describedby="example5_info"
                            >
                                <thead>
                                    <tr role="row">
                                        {/* <th
                                            className="sorting_asc"
                                            tabIndex={0}
                                            aria-controls="example5"
                                            rowSpan={1}
                                            colSpan={1}
                                            aria-sort="ascending"
                                            aria-label="
													
														
														
													
												: activate to sort column descending"
                                            style={{ width: 32 }}
                                        >
                                            <div className="custom-control custom-checkbox">
                                                <input
                                                    type="checkbox"
                                                    // onClick={() => chackboxFun("all")}
                                                    className="custom-control-input"
                                                    id="checkAll"
                                                    required
                                                />
                                                <label
                                                    className="custom-control-label"
                                                    htmlFor="checkAll"
                                                />
                                            </div>
                                        </th> */}
                                        <th
                                            className="sorting"
                                            tabIndex={0}
                                            aria-controls="example5"
                                            rowSpan={1}
                                            colSpan={1}
                                            aria-label="Patient ID: activate to sort column ascending"
                                            style={{ width: 73 }}
                                        >
                                            Donor Photo 
                                        </th>
                                        <th
                                            className="sorting"
                                            tabIndex={0}
                                            aria-controls="example5"
                                            rowSpan={1}
                                            colSpan={1}
                                            aria-label="Patient ID: activate to sort column ascending"
                                            style={{ width: 73 }}
                                        >
                                            Donor ID
                                        </th>
                                        <th
                                            className="sorting"
                                            tabIndex={0}
                                            aria-controls="example5"
                                            rowSpan={1}
                                            colSpan={1}
                                            aria-label="Date Check in: activate to sort column ascending"
                                            style={{ width: 100 }}
                                        >
                                            Gender
                                        </th>
                                        <th
                                            className="sorting"
                                            tabIndex={0}
                                            aria-controls="example5"
                                            rowSpan={1}
                                            colSpan={1}
                                            aria-label="Patient Name: activate to sort column ascending"
                                            style={{ width: 100 }}
                                        >
                                            Donor Name
                                        </th>
                                        <th
                                            className="sorting"
                                            tabIndex={0}
                                            aria-controls="example5"
                                            rowSpan={1}
                                            colSpan={1}
                                            aria-label="Status: activate to sort column ascending"
                                            style={{ width: 106 }}
                                        >
                                            Status
                                        </th>
                                        <th
                                            className="sorting"
                                            tabIndex={0}
                                            aria-controls="example5"
                                            rowSpan={1}
                                            colSpan={1}
                                            aria-label="Patient Name: activate to sort column ascending"
                                            style={{ width: 100 }}
                                        >
                                            Action
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {props.eligibleDonors.map((donor) => (
                                        <tr role="row" className="odd">
                                            {/* <td className="sorting_1">
                                            <div className="custom-control custom-checkbox ">
                                                <input
                                                    type="checkbox"
                                                    // onClick={() => chackboxFun()}
                                                    className="custom-control-input"
                                                    id="customCheckBox2"
                                                    required
                                                />
                                                <label
                                                    className="custom-control-label"
                                                    htmlFor="customCheckBox2"
                                                />
                                            </div>
                                        </td> */}
                                            <td>
                                                <img
                                                    src={donor.profileImage || defaultProfileImage}
                                                    alt="Profile"
                                                    style={{ width: 50, height: 50, borderRadius: "50%" }}
                                                />
                                            </td>
                                            <td>{donor._id}</td>
                                            <td>{donor.gender}</td>
                                            <td>{donor.firstName + " " + donor.secondName}</td>
                                            <td>{donor.status}</td>


                                            <td>
                                                <Dropdown className="dropdown ml-auto text-right">
                                                    <Dropdown.Toggle
                                                        variant=""
                                                        className="btn-link i-false"
                                                        data-toggle="dropdown"
                                                    >
                                                        <svg
                                                            width="24px"
                                                            height="24px"
                                                            viewBox="0 0 24 24"
                                                            version="1.1"
                                                        >
                                                            <g
                                                                stroke="none"
                                                                strokeWidth={1}
                                                                fill="none"
                                                                fillRule="evenodd"
                                                            >
                                                                <rect x={0} y={0} width={24} height={24} />
                                                                <circle fill="#000000" cx={5} cy={12} r={2} />
                                                                <circle fill="#000000" cx={12} cy={12} r={2} />
                                                                <circle fill="#000000" cx={19} cy={12} r={2} />
                                                            </g>
                                                        </svg>
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu className="dropdown-menu dropdown-menu-right">
                                                        <Dropdown.Item>Accept Patient</Dropdown.Item>
                                                        <Dropdown.Item>Reject Order</Dropdown.Item>
                                                        <Dropdown.Item>View Details</Dropdown.Item>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
                                <div className="dataTables_info">
                                    Showing {activePage * pageSize + 1} to{" "}
                                    {(activePage + 1) * pageSize > props.totalEligibleDonors
                                        ? props.totalEligibleDonors
                                        : (activePage + 1) * pageSize}{" "}
                                    of {props.totalEligibleDonors} entries
                                </div>
                                <div
                                    className="dataTables_paginate paging_simple_numbers"
                                    id="example5_paginate"
                                >
                                    <Link
                                        className={`paginate_button previous ${activePage === 0 ? "disabled" : ""
                                            }`}
                                        to="#"
                                        onClick={() => activePage > 0 && handlePageClick(activePage - 1)}
                                    >
                                        Previous
                                    </Link>
                                    <span>
                                        {[...Array(totalPages)].map((_, i) => (
                                            <Link
                                                key={i}
                                                to="#"
                                                className={`paginate_button ${activePage === i ? "current" : ""
                                                    }`}
                                                onClick={() => handlePageClick(i)}
                                            >
                                                {i + 1}
                                            </Link>
                                        ))}
                                    </span>
                                    <Link
                                        className={`paginate_button next ${activePage + 1 === totalPages ? "disabled" : ""
                                            }`}
                                        to="#"
                                        onClick={() =>
                                            activePage + 1 < totalPages && handlePageClick(activePage + 1)
                                        }
                                    >
                                        Next
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DonorTable;
